var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#CE06CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11932 17.5V16.2273L12.0568 12.1477C12.4773 11.7045 12.8239 11.3163 13.0966 10.983C13.3731 10.6458 13.5795 10.3258 13.7159 10.0227C13.8523 9.7197 13.9205 9.39773 13.9205 9.05682C13.9205 8.67045 13.8295 8.33712 13.6477 8.05682C13.4659 7.77273 13.2178 7.55492 12.9034 7.40341C12.589 7.24811 12.2348 7.17045 11.8409 7.17045C11.4242 7.17045 11.0606 7.25568 10.75 7.42614C10.4394 7.59659 10.2008 7.83712 10.0341 8.14773C9.86742 8.45833 9.78409 8.82197 9.78409 9.23864H8.10795C8.10795 8.5303 8.27083 7.91098 8.59659 7.38068C8.92235 6.85038 9.36932 6.43939 9.9375 6.14773C10.5057 5.85227 11.1515 5.70455 11.875 5.70455C12.6061 5.70455 13.25 5.85038 13.8068 6.14205C14.3674 6.42992 14.8049 6.82386 15.1193 7.32386C15.4337 7.82008 15.5909 8.38068 15.5909 9.00568C15.5909 9.4375 15.5095 9.85985 15.3466 10.2727C15.1875 10.6856 14.9091 11.1458 14.5114 11.6534C14.1136 12.1572 13.5606 12.7689 12.8523 13.4886L10.5398 15.9091V15.9943H15.7784V17.5H8.11932Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.dadd0fa9a933ee06a0eb5742f5640f1d.svg";
export { ForwardRef as ReactComponent };